import { IQuery } from "../../../../server/query";

export function ensureEnabledQueryBuilder(
  queryBuilder?: (search: string) => IQuery
): (search: string) => IQuery {
  queryBuilder ??= (search: string) => {
    return { NameContains: search };
  };
  return (search) => {
    return {
      ...queryBuilder!(search),
      Disabled: false,
    };
  };
}

export function ensureEnabledQueryBuilder2(
  queryBuilder?: (search: string) => IQuery
): (search: string) => IQuery {
  queryBuilder ??= (search: string) => {
    return {};
  };
  return (search) => {
    return {
      ...queryBuilder!(search),
    };
  };
}
